import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["anchorTopPosition", "headerHeight", "isAuthenticated", "isPrimary", "onNavItemClick", "openItems", "onNavItemHover"];
import React from 'react';
import { alpha, styled } from '@mui/material/styles';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';
import { SideNavMenu } from './SideNavMenu';
import { jsx as _jsx } from "react/jsx-runtime";
export function SideNavPopover(props) {
  var anchorTopPosition = props.anchorTopPosition,
    headerHeight = props.headerHeight,
    isAuthenticated = props.isAuthenticated,
    _props$isPrimary = props.isPrimary,
    isPrimary = _props$isPrimary === void 0 ? false : _props$isPrimary,
    onNavItemClick = props.onNavItemClick,
    _props$openItems = props.openItems,
    openItems = _props$openItems === void 0 ? [] : _props$openItems,
    onNavItemHover = props.onNavItemHover,
    others = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(StyledPopover, _extends({}, others, {
    PaperProps: {
      sx: {
        '&::-webkit-scrollbar': {
          width: '6px !important'
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#C4C4C4'
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'none !important'
        },
        borderRadius: 0,
        height: '100%',
        overflow: 'hidden',
        top: "0px !important"
      }
    },
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'top'
    },
    elevation: 3,
    headerHeight: headerHeight,
    marginThreshold: 0,
    transformOrigin: {
      horizontal: 'left',
      vertical: 'top'
    },
    "data-element": "StyledPopover",
    "data-component": "SideNavPopover",
    "data-source-file": "SideNavPopover.tsx",
    children: /*#__PURE__*/_jsx(StyledStack, {
      direction: "row",
      isPrimary: isPrimary,
      "data-element": "StyledStack",
      "data-source-file": "SideNavPopover.tsx",
      children: openItems.map(function (openItem, index) {
        var level = index + 1;
        return /*#__PURE__*/_jsx(SideNavMenu, {
          "data-testid": "".concat(openItem.key),
          isAuthenticated: isAuthenticated,
          isPrimary: isPrimary,
          level: level,
          navItem: openItem,
          onNavItemClick: onNavItemClick,
          onNavItemHover: onNavItemHover
        }, openItem.key);
      })
    })
  }));
}
var StyledStack = styled(Stack, {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isPrimary';
  }
})(function (_ref) {
  var isPrimary = _ref.isPrimary,
    theme = _ref.theme;
  return {
    backgroundColor: isPrimary ? theme.palette.common.white : theme.palette.neutral[10],
    borderLeft: "ridge 0.5px ".concat(theme.palette.grey[300]),
    height: '100%',
    width: '100%'
  };
});
var StyledPopover = styled(Popover)(function (_ref2) {
  var headerHeight = _ref2.headerHeight,
    theme = _ref2.theme;
  return {
    backgroundColor: alpha(theme.palette.common.black, 0.4),
    height: '100%',
    top: headerHeight,
    zIndex: 100
  };
});